import { render, staticRenderFns } from "./buscaConvenio.vue?vue&type=template&id=6dd7f303&scoped=true"
import script from "./buscaConvenio.vue?vue&type=script&lang=js"
export * from "./buscaConvenio.vue?vue&type=script&lang=js"
import style0 from "./buscaConvenio.vue?vue&type=style&index=0&id=6dd7f303&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd7f303",
  null
  
)

export default component.exports